export default __webpack_public_path__ + "static/media/magiceden.c345d325.svg";